import { render, staticRenderFns } from "./buildingdetail.vue?vue&type=template&id=024989a1&scoped=true&"
import script from "./buildingdetail.vue?vue&type=script&lang=js&"
export * from "./buildingdetail.vue?vue&type=script&lang=js&"
import style0 from "./buildingdetail.vue?vue&type=style&index=0&id=024989a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024989a1",
  null
  
)

export default component.exports